import { UserCardState } from "../interface/interface";
import { officeApi } from "./config";
import { NetworkError } from "./postapi";

type UserReturn = {
  state: boolean;
  data: UserCardState[] | undefined;
};

export type Search_User_Type = {
  login_id: string;
  agr_adv?: number;
  leader?: boolean;
  isProject?: number;
};

const GetUser = (
  serach: Search_User_Type | undefined,
  page: number,
  limit: number
) => {
  return officeApi
    .get(
      `/auth/usr/usr?row_limit_cnt=${limit}&page=${page}${
        serach?.login_id ? `&login_id=${serach.login_id}` : ""
      }${serach?.agr_adv !== undefined ? `&agr_adv=${serach.agr_adv}` : ""}${
        serach?.isProject !== undefined ? `&is_prjt=${serach.isProject}` : ""
      }${serach?.leader ? `&usr_typ=READ` : ""}`,

      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(
      ({
        data,
      }: {
        data: {
          lst: UserCardState[];
          pg: any;
        };
      }) => {
        return {
          state: true,
          data,
        };
      }
    )
    .catch((err) => {
      return NetworkError;
    });
};

const GetLeader = (): Promise<UserReturn> => {
  return officeApi
    .get(`/auth/usr/grpUsr`)
    .then(({ data }: { data: UserCardState[] }) => {
      return {
        state: true,
        data,
      };
    })
    .catch((err) => {
      return NetworkError;
    });
};

export { GetUser, GetLeader };
